function reOrderRow(arr, from, to) {
	const objData = [...arr];
	objData.splice(to, 0, objData.splice(from, 1)[0]);

	return objData;
}
/**
 * Special case for handling scenario in Windows OS browsers,
 * when scrollbar appears in TBody,
 * learn more from rtc defect 235531
 */
function resizeThead(tbody) {
	const thead = tbody.parentElement.children[0].children[0];
	if (navigator.appVersion.indexOf('Win') !== -1) {
		if (tbody.scrollHeight > tbody.clientHeight) {
			const SCROLLBAR_WIDTH = '17px';
			thead.style.width = `calc(100% - ${SCROLLBAR_WIDTH})`;
		}
	}
}

export default {
	reOrderRow,
	resizeThead,
};
